module.exports = __webpack_public_path__ + "img/poster-tokido.80a02b38.jpg";